<!--
  «Documentación de integración» — consola de CrediTotal.

  Tres piezas para descargar y mandarle a un comercio que se va a integrar (a SAP, a Odoo, al que
  le lleve el punto de venta): los dos manuales técnicos y la colección de Postman. Los archivos
  los deja Juan a mano en `src/assets/manuales/`; esta pantalla sólo los ofrece, y si alguno
  todavía no está, el botón de esa tarjeta lo dice en vez de romper.
-->
<div class="kb-page kb-gateway">

  <!-- ══ Portada ══════════════════════════════════════════════════════════════════════════════ -->
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title flex items-center gap-2">
        <i class="fas fa-book text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Documentación de integración
      </h1>
      <p class="kb-page-meta">
        Los manuales para integrar un comercio por marketplace o por caja, y la colección de
        Postman para probar sus llamados — para bajar y mandarle a quien va a construir esa
        integración.
      </p>
    </div>
  </div>

  <!-- ══ El aviso — la dirección de estos manuales es de ejemplo ════════════════════════════════
       Corre en los tres archivos, así que va una sola vez, arriba, y no repetido en cada
       tarjeta. -->
  <div class="kb-aviso kb-aviso-alerta">
    <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">Estos manuales no llevan la dirección real de la pasarela</p>
      <p>
        Usan una dirección de ejemplo a propósito. La dirección real y las credenciales van
        aparte, por canal directo, nunca dentro de un documento que circula.
      </p>
    </div>
  </div>

  <!-- ══ Las tres tarjetas ═══════════════════════════════════════════════════════════════════════ -->
  <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
    <div class="kb-tarjeta" *ngFor="let m of manuales">
      <div class="kb-tarjeta-cab">
        <div class="space-y-1">
          <h2 class="flex items-start gap-2 text-base font-semibold leading-snug text-foreground">
            <i class="fas" [ngClass]="m.icono" aria-hidden="true"></i>
            <span>{{ m.titulo }}</span>
          </h2>
        </div>
      </div>

      <div class="kb-tarjeta-cuerpo flex flex-1 flex-col">
        <p class="text-sm text-foreground">{{ m.paraQueSirve }}</p>
        <p class="mt-2 text-sm text-muted-foreground">{{ m.aQuienSeLeDa }}</p>

        <div class="mt-auto pt-5">
          <!-- Comprobando: ni disponible ni no-disponible todavía. -->
          <button type="button" class="kb-btn kb-btn-outline w-full" disabled
                  *ngIf="disponible[m.archivo] === undefined">
            <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>Comprobando el archivo…
          </button>

          <!-- Disponible: descarga de verdad. -->
          <button type="button" class="kb-btn kb-btn-primary w-full"
                  *ngIf="disponible[m.archivo] === true"
                  (click)="descargar(m)">
            <i class="fas fa-download" aria-hidden="true"></i>Descargar
          </button>

          <!-- No disponible: se ve igual que las demás tarjetas, pero el botón avisa y no
               reacciona — no hay archivo detrás todavía. -->
          <ng-container *ngIf="disponible[m.archivo] === false">
            <button type="button" class="kb-btn kb-btn-outline w-full" disabled>
              <i class="fas fa-clock" aria-hidden="true"></i>Todavía no está disponible
            </button>
            <p class="mt-2 text-xs text-muted-foreground">
              Este archivo no se ha subido a la consola. Avísale a quien lo esté redactando.
            </p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

</div>
